const PropertiesPageConstants = {
  DISPLAY_PAYMENTS_NOTIFICATION: 'displayPaymentsNotification',
  DISPLAY_APPLICATIONS_NOTIFICATION: 'displayApplicationsNotification',
  DISPLAY_LEASES_NOTIFICATION: 'displayLeasesNotification',
  DISPLAY_LISTING_CLAIM_COMPLETE_BANNER: 'displayListingClaimCompleteBanner',
} as const;

export default PropertiesPageConstants;
